<template>
    <div
        @mouseover="handleStartAnimate"
        @mouseleave="handleResetAnimate"
        class="marketing-calendar-container"
    >
        <SingleMarketingCalendar
            :additionalMonths="calendarProps.additionalMonths"
            :calendar.sync="calendarProps.calendar"
            :customCalendarView="calendarProps.calendarView"
            :styleOptions="calendarProps.styleOptions"
        />
    </div>
</template>
<script>
    import SingleMarketingCalendar from '@/components/ui/calendars/SingleMarketingView.vue'

    export default {
        name: 'MarketingCalendar',

        emits: [],
        components: { SingleMarketingCalendar },
        data: () => ({
            calendarProps: {
                animationTimer: null,
                animationTimeout: 1000,
                additionalMonths: 0,
                calendar: [],
                styleOptions: {
                    background: {
                        background: '#262626'
                    },
                    font: {
                        'font-family': 'Studio Pro',
                        'font-size': '20px'
                    }
                },
                calendarView: [
                    {
                        label: '',
                        days: [
                            {
                                day: null,
                                past: true,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: null,
                                past: true,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 1,
                                past: true,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 2,
                                past: true,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 3,
                                past: true,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 4,
                                past: true,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 5,
                                past: true,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: 'red'
                            },
                            {
                                day: 6,
                                past: true,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 7,
                                past: true,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 8,
                                past: true,
                                current: true,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 9,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 10,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 11,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: 'orange'
                            },
                            {
                                day: 12,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: 'orange'
                            },
                            {
                                day: 13,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: 'orange'
                            },
                            {
                                day: 14,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 15,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 16,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 17,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 18,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: 'yellow'
                            },
                            {
                                day: 19,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 20,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 21,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 22,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 23,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 24,
                                past: false,
                                current: false,
                                hover: true,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 25,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 26,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: 'yellow'
                            },
                            {
                                day: 27,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 28,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 29,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: ''
                            },
                            {
                                day: 30,
                                past: false,
                                current: false,
                                hover: false,
                                animate: false,
                                leaveAnimation: false,
                                color: 'yellow'
                            }
                        ]
                    }
                ]
            }
        }),

        methods: {
            handleStartAnimate() {
                let calendar = this.calendarProps.calendar

                this.animationTimeout = setTimeout(() => {
                    for (let i = 0; i < calendar[0].days.length; i++) {
                        let day = calendar[0].days[i]

                        if (day.color && !day.animate) {
                            day.leaveAnimation = false
                            day.animate = true
                            return
                        }
                    }
                }, this.animationTimer)
            },
            handleResetAnimate() {
                let calendar = this.calendarProps.calendar

                for (let i = 0; i < calendar[0].days.length; i++) {
                    let day = calendar[0].days[i]

                    if (i === calendar[0].days.length - 1 && day.color && day.animate) {
                        this.resetAnimations()
                        return
                    }
                }
            },
            resetAnimations() {
                this.calendarProps.calendar[0].days.forEach((day) => {
                    if (day.day === 18) {
                        day.leaveAnimation = true
                    }
                    day.animate = false
                })
            }
        },
        beforeDestory() {
            clearTimeout(this.animationTimeout)
        }
    }
</script>
<style lang="scss" scoped>
    .marketing-calendar-container {
        max-width: 513px;
        max-height: 400px;
    }
    @media (max-width: 600px) {
        .marketing-calendar-container {
            padding: 0 16px 0 0;
        }
    }
</style>
